/**
 * Created by h3 on 2017-08-24.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap";
import {TeslaSymbols} from "../../../config/TeslaSymbols";
import {TeslaStateReelSymbol} from "../../reel/TeslaStateReelSymbol";
import {TeslaParsedGameData} from "../../server/data/TeslaParsedGameData";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";

export class TeslaWildAttentionController extends ReelStopPresentationController {
    private _attentionTimelines:(TimelineLite | null)[];
    private _overlayWildsBeforeSpinStop:boolean[][];

    constructor(index:number) {
        super(index, "TeslaWildAttentionController");
        this._attentionTimelines = [null, null, null, null, null];
    }


    protected parseFeatureGameData(data:TeslaParsedGameData):void {
        this._overlayWildsBeforeSpinStop = data.overlayWildsBeforeSpinStop;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(!this.tryPlayBouncePresentation(data)) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private tryPlayBouncePresentation(data:IReelStoppedData):boolean {
        let wildSymbols:TeslaStateReelSymbol[] = [];


        for(let i:number = 0; i < 3; i++) {
            const symbol:TeslaStateReelSymbol = <TeslaStateReelSymbol>Reels.getSymbol(data.reelId, i)!;


            if(this._overlayWildsBeforeSpinStop[data.reelId][i]) {
                if(symbol && symbol.symName === TeslaSymbols.W || symbol.symName === TeslaSymbols.W2) {
                    symbol.changeState({
                        state : TeslaGameConfig.instance.SYMBOL_STATES.attention,
                        frames : [0, 0],
                        fadeInDuration : 0
                    });
                }
            }

            if(!this._overlayWildsBeforeSpinStop[data.reelId][i]) {
                if(symbol && symbol.symName === TeslaSymbols.W || symbol.symName === TeslaSymbols.W2) {
                    wildSymbols.push(symbol);
                }
            }

        }

        if(wildSymbols.length <= 0) {
            return false;
        }

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this.playSound());
        for(let i:number = 0; i < wildSymbols.length; i++) {
            let wildSymbol:TeslaStateReelSymbol = wildSymbols[i];
            let animation:Timeline | null = wildSymbol.changeState({
                state : TeslaGameConfig.instance.SYMBOL_STATES.attention,
                fadeInDuration : 0,

            });


            if(animation != null) {
                tl.add(animation, 0);

            }
        }

        tl.add(() => this.dispatchCompleteEvent(data.reelId));
        this._attentionTimelines[data.reelId] = tl;
        return true;
    }

    protected resetFeature():void {
        for(let i:number = 0; i < this._attentionTimelines.length; i++) {
            let tl:TimelineLite | null = this._attentionTimelines[i];
            if(tl && tl.isActive()) {
                tl.pause();
                tl.seek(tl.totalDuration(), false);
            }
            tl = null;
            this._attentionTimelines[i] = null;
        }
    }

    private playSound() {
        SlotGame.sound.playEffect(TeslaSoundConfig.instance.WILD_ATTENTION);
    }
}